<template>
  <section class="login-form">
    <div class="container-fluid" v-if="!isSuccess">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="login-form-img">
            <img :src="optChangeEmailImg" alt="login form img" />
          </div>
        </div>

        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="login-form-inputs" v-if="OTPScreen">
            <a
              v-if="!lastSetp"
              class="back-btn"
              href="javascript:void(0)"
              @click.prevent="showUserProfile()"
            >
              <img src="../../../Assets/Images/arrow-left.png" alt="arrow" />
              <span>{{ objOtp.backBtn }}</span>
            </a>
            <a
              v-if="lastSetp"
              class="back-btn"
              href="javascript:void(0)"
              @click.prevent="showEmailScreen()"
            >
              <img src="../../../Assets/Images/arrow-left.png" alt="arrow" />
              <span>{{ objOtp.backBtn }}</span>
            </a>
            <div class="login-form-logo">
              <img src="../../../Assets/Images/logo-login.png" alt="Eda logo" />
            </div>
            <h3 class="generic-description">{{ objOtp.OTPTitle }}</h3>
            <p class="input-ask">{{ objOtp.OTPConfirmEmail }}</p>
            <form v-on:submit.prevent="onSubmit" class="form-container">
              <div class="input-field">
                <input
                  type="text"
                  :placeholder="objOtp.OTPVerifyCode"
                  v-model.trim="formData.UserOTP"
                />
                <p>
                  <span class="form-container__error-msg" v-if="OtpRequired">{{
                    objOtp.OTPVerifyCodeRequired
                  }}</span>
                  <span class="form-container__error-msg" v-if="OtpNotValid">{{
                    objOtp.OTPVerifyCodeNotValid
                  }}</span>
                </p>
              </div>
              <button
                v-if="!objOtp.isForgetPasswordPage"
                @click.prevent="onSubmit"
                type="submit"
                class="custom-btn"
              >
                {{ objOtp.submit }}
              </button>
              <div class="news-letter__loader" v-if="isLoading">
                <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner" />
              </div>
            </form>
          </div>

          <div class="login-form-inputs" v-if="!OTPScreen">
            <a
              class="back-btn"
              @click.prevent="ShowFirstOTP()"
            >
              <img src="../../../Assets/Images/arrow-left.png" alt="arrow" />
              <span>{{ objOtp.backBtn }}</span>
            </a>
            <div class="login-form-logo">
              <img src="../../../Assets/Images/logo-login.png" alt="Eda logo" />
            </div>
            <h3 class="generic-description">
              {{ objOtp.formEmailTitle }}
            </h3>
            <p class="input-ask">{{ objOtp.formEmailSubTitle }}</p>
            <form v-on:submit.prevent="submitNewEmail" class="form-container">
              <div class="input-field">
                <input
                  type="text"
                  :placeholder="objOtp.formEmail"
                  v-model.trim="$v.formEmail.Email.$model"
                />
                <p v-if="$v.formEmail.Email.$dirty">
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formEmail.Email.required"
                    >{{ objOtp.formEmailRequired }}</span
                  >
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formEmail.Email.emailValidation"
                    >{{ objOtp.formEmailNotValid }}</span
                  >
                </p>
              </div>
              <button type="submit" class="custom-btn">
                {{ objOtp.submit }}
              </button>
              <div class="news-letter__loader" v-if="isLoading">
                <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner" />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid" v-if="isSuccess">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="login-form-img">
            <img :src="optChangeEmailImg" alt="login form img" />
          </div>
        </div>

        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="success-block">
            <div class="login-form-logo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                id="check"
                width="144"
                height="144"
                viewBox="0 0 144 144"
              >
                <defs></defs>
                <g id="Group_1310">
                  <g id="Group_1309">
                    <path
                      id="Path_6591"
                      d="M72 0a72 72 0 1 0 72 72A72 72 0 0 0 72 0zm0 139.355A67.355 67.355 0 1 1 139.355 72 67.355 67.355 0 0 1 72 139.355z"
                      class="cls-1"
                    />
                    <path
                      id="Path_6592"
                      d="M187.073 156.75l-47.132 47.132-23.906-23.906a2.323 2.323 0 0 0-3.284 3.284l25.549 25.549a2.323 2.323 0 0 0 3.284 0l48.774-48.774a2.323 2.323 0 0 0-3.284-3.284z"
                      class="cls-1"
                      transform="translate(-79.554 -110.78)"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <h3 class="generic-description">{{ objOtp.successMessage }}</h3>
            <div class="success-screen-btns">
              <a href="/" class="custom-btn"> {{ objOtp.home }} </a>
              <a :href="objOtp.loginUrl" class="custom-btn">
                {{ objOtp.login }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="toaster" v-bind:class="{ 'show-toaster': genericMessage }">
      {{ responseMsg }}
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Vuelidate from "vuelidate";
import { required, helpers } from "vuelidate/lib/validators";
import { headers, key } from '../../../Scripts/genericJSFile.js';

Vue.use(Vuelidate);

const emailValidation = helpers.regex(
  "alpha",
  /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
);

let baseUrl = document.location.origin;
let apiUrl = baseUrl + "";

export default {
  props: {
    signIn: {
      type: String,
    },
    objOtp: {
      type: Object,
        },

  },
  data() {
    return {
      optChangeEmailImg: this.objOtp.imgDesktop,
      isSuccess: false,
      isLoading: false,
      OtpNotValid: false,
      OtpRequired: false,
      OTPScreen: true,
      lastSetp: false,
      genericMessage: false,
      responseMsg: "",
      formData: {
        Email: "",
        UserOTP: "",
      },
      formEmail: {
        Email: "",
      },
    };
  },
  validations: {
    formEmail: {
      Email: {
        required,
        emailValidation,
      },
    },
  },
  methods: {
      onSubmit() {
      if (this.formData.UserOTP != "") {
        this.isLoading = true;
        let headers = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        let formObj = {
            Email: this.objOtp.userEmail,
            UserOTP: this.formData.UserOTP,
            EdaID: this.objOtp.EdaID
        };

        if (this.lastSetp) {
          formObj = {
            Email: this.formEmail.Email,
              UserOTP: this.formData.UserOTP,
              EdaID: this.objOtp.EdaID
          };
        }

        axios
          .post(`${apiUrl}/Umbraco/Surface/Users/ValidateOTP`, formObj, headers)
          .then((res) => {
            this.isLoading = false;
            if (res.data == true) {
              this.OTPScreen = false;
              this.formData.UserOTP = "";
              if (this.lastSetp) {
                this.isSuccess = true;
                this.signOut();
              }
            } else {
              this.OtpNotValid = true;
              this.OtpRequired = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.OtpRequired = true;
        this.OtpNotValid = false;
      }
    },
      submitNewEmail() {
      this.$v.formEmail.$touch();
      if (this.$v.formEmail.$anyError) {
        return;
      } else {
        this.isLoading = true;
        let formObj = {
          Email: this.formEmail.Email,
        };
          let token = localStorage.getItem("token");
          //if (sessionStorage.getItem("token")) {
          //    token = sessionStorage.getItem("token")
          //} else {
          //    token = localStorage.getItem("token")
          //}
        let headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        };
        axios
          .post(
            `${apiUrl}/Umbraco/Surface/Users/UpdateUserEmail`,
            formObj,
            headers
          )
            .then((res) => {
                this.isLoading = false;
            if (res.data.IsOperationSucceed) {
                this.OTPScreen = true;
                this.lastSetp = true;
              } else {
                    this.responseMsg = res.data.Message,
                    this.genericMessage = true;
                setTimeout(() => {
                    this.genericMessage = false;
                }, 3000);
            }
            
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    signOut() {
        //let token = localStorage.getItem("token");
        //let headers = {
        //    headers: {
        //        'Authorization': `Bearer ${token}`
        //    },
        //};
      axios
        .post(`${apiUrl}/Umbraco/Surface/Users/signout`, key, headers)
        .then(() => {
            localStorage.removeItem('token');
            //sessionStorage.removeItem('token');
          //window.location.href = apiUrl;
        })
        .catch(() => {
        });
      },
    ShowFirstOTP() {
      this.OTPScreen = true;
    },
    showEmailScreen() {
      this.OTPScreen = false;
      this.lastSetp = false;
    },
    passPassword(value) {
      this.isSuccess = value;
    },
    showUserProfile() {
      this.$emit("userProfile", false);
    },
    backLogin() {
      this.$emit("childToParent", false);
    },
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.optChangeEmailImg = this.objOtp.imgMobile;
    }
    if (document.querySelector(".navbar.navbar-expand-lg")) {
      document.querySelector(".navbar.navbar-expand-lg").style.display = "none";
      document.querySelector(".breadcrumb-container").style.display = "none";
      if (document.querySelector(".generic-banner")) {
        document.querySelector(".generic-banner").style.display = "none";
      }
      document.querySelector(".footer").style.display = "none";
      if (document.querySelector(".register-form-container")) {
        document.querySelector(".register-form-container").style.display =
          "none";
      }
      document.querySelector(".copy-right").style.display = "none";
    }
  },
};
</script>
